import type { OptionsDocument, QuoteDocument } from 'paintscout'
import uuid from 'uuid'
import type { Deal } from '@paintscout/api'
import { getPipelines } from '../../options/get-pipelines'
import { getContactAddress } from '../../quote/contact/get-contact-address/get-contact-address'

export function createDealFromQuote({ quote, options }: { quote: QuoteDocument; options: OptionsDocument }): Deal {
  const contact = quote.contact
  const pipelines = getPipelines({ options })
  const pipeline = pipelines.find((p) => p.key === 'sales-pipeline')

  const contactAddress = getContactAddress(contact)
  const jobAddress = quote.jobAddress?.address ? quote.jobAddress : contactAddress

  const deal: Partial<Deal> = {
    _id: uuid(),
    created: Date.now(),
    value: quote.totals.balance_due + quote.totals.amount_paid,
    quoteType: quote.int_ext?.value,
    name: contact.last_name || contact.first_name,
    owner: quote.owner
      ? {
          id: quote.owner.id,
          firstName: quote.owner.firstName,
          lastName: quote.owner.lastName
        }
      : null,
    contact: {
      id: contact.id || (contact as any)._id,
      company: contact.company,
      companyId: contact.companyDocId
    },
    jobAddress,
    pipeline: {
      value: pipeline.key,
      label: pipeline.label
    },
    stage: {
      value: pipeline.stages[0].key
    },
    lead_source: contact.lead_source || ''
  }

  return deal as Deal
}
